import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

const SparePartsProcurement = () => {
  return (
    <div>

      {/* Cover Image Section */}
      <div className="service-cover">
        <img
          src="/images/spare.webp"
          alt="Spare Parts Procurement"
          className="service-cover-image"
        />
        <div className="service-cover-text">
          <h1>Spare Parts Procurement & Delivery</h1>
          <p>Reliable, Fast, and Global Maritime Spare Part Solutions</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Procurement Expertise for Maritime Efficiency</h2>
          <p>
            Downtime costs money. That’s why our Spare Parts Procurement and Delivery service ensures vessels receive
            the right parts at the right time—anywhere in the world. From engine components to navigation systems,
            we source high-quality parts from trusted OEMs and suppliers.
          </p>
          <p>
            Whether it’s routine maintenance or emergency repair, our logistics coordination and global vendor
            network keep your vessel fully operational and compliant with safety and technical standards.
          </p>
        </div>

        {/* Services Grid */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/sourcing.webp" alt="Sourcing Parts" className="service-card-image" />
            <div className="service-card-content">
              <h3>Global Sourcing</h3>
              <ul>
                <li>OEM and compatible parts for all major ship systems</li>
                <li>Engine, electrical, hydraulic, and deck machinery components</li>
                <li>Direct partnerships with certified manufacturers</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/maintanance.webp" alt="Inventory Management" className="service-card-image" />
            <div className="service-card-content">
              <h3>Inventory Support</h3>
              <ul>
                <li>Critical spares identification</li>
                <li>Maintenance planning integration</li>
                <li>Ship-specific procurement lists</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/delivery.webp" alt="Logistics and Delivery" className="service-card-image" />
            <div className="service-card-content">
              <h3>Rapid Delivery</h3>
              <ul>
                <li>Door-to-deck logistics in all major ports</li>
                <li>Customs clearance and documentation handling</li>
                <li>24/7 global coordination for urgent needs</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/quality.webp" alt="Quality Assurance" className="service-card-image" />
            <div className="service-card-content">
              <h3>Quality Assurance</h3>
              <ul>
                <li>Verified certifications and test results</li>
                <li>Inspection before dispatch</li>
                <li>Returns and replacements managed professionally</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SparePartsProcurement;
